var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppsflyer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17024 12.6664L8.08873 23.9406C8.49283 24.7087 9.4889 25.3321 10.3117 25.3301L22.3854 25.3046C23.2096 25.3029 23.5497 24.6779 23.146 23.9085L17.2269 12.635C16.8231 11.8654 15.8273 11.2437 15.0036 11.2455L2.93018 11.2706C2.91155 11.2706 2.89353 11.2712 2.8749 11.2712C2.09165 11.3008 1.77501 11.9142 2.17024 12.6664Z",
    fill: "#75B82C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1041 25.804L28.6882 32.4917C28.9321 32.9479 29.5283 33.3141 30.0193 33.3085L37.213 33.2325C37.7042 33.2275 37.9024 32.8535 37.6587 32.3969L34.0758 25.7097C33.8315 25.2532 33.2344 24.8879 32.7446 24.8931L25.5508 24.9687C25.5424 24.9687 25.5344 24.9687 25.526 24.9687C25.0532 24.9862 24.8641 25.3545 25.1041 25.804Z",
    fill: "#75B82C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.144 0.408714L17.9512 9.64108C17.4596 10.2718 17.3945 11.4021 17.805 12.1689L23.8184 23.392C24.2283 24.1574 24.9595 24.2679 25.4503 23.6387L32.6438 14.4045C33.1345 13.775 33.2003 12.6434 32.789 11.8773L26.7764 0.653894C26.538 0.210909 26.1934 -0.0124302 25.8497 -0.000432968C25.6002 0.00971794 25.3507 0.143539 25.144 0.408714Z",
    fill: "#3D90D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4607 25.9153L19.1737 31.4166C18.8802 31.7923 18.8424 32.4663 19.0864 32.9221L22.6697 39.6096C22.9149 40.0662 23.35 40.1318 23.6429 39.7561L27.9286 34.2555C28.2209 33.8792 28.2599 33.2046 28.0161 32.7495L24.4326 26.0617C24.2915 25.7976 24.0855 25.6643 23.8803 25.6711C23.7323 25.6762 23.5829 25.7565 23.4607 25.9153Z",
    fill: "#3D90D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsflyer);
export default __webpack_public_path__ + "static/media/appsflyer.865cc5aa843fa73cabd090e65eab773a.svg";
export { ForwardRef as ReactComponent };